import api from './client'
import { User, Company, Department, CompanyDepartment, CreateUserData, ApiResponse } from '../types'

export const getUsers = async (): Promise<ApiResponse<User[]>> => {
  const response = await api.get('/users/')
  return response.data
}

export const getUserById = async (userId: string): Promise<ApiResponse<User>> => {
  const response = await api.get(`/users/${userId}/`)
  return response.data
}

export const createUser = async (userData: CreateUserData): Promise<ApiResponse<User>> => {
  const response = await api.post('/users/', userData)
  return response.data
}

export const updateUser = async (userId: string, userData: Partial<CreateUserData>): Promise<ApiResponse<User>> => {
  const response = await api.patch(`/users/${userId}/`, userData)
  return response.data
}

export const deleteUser = async (userId: string): Promise<ApiResponse<null>> => {
  const response = await api.delete(`/users/${userId}/`)
  return response.data
}

export const getCompanies = async (): Promise<ApiResponse<Company[]>> => {
  const response = await api.get('/companies/')
  return response.data
}

export const createCompany = async (companyData: { name: string }): Promise<ApiResponse<Company>> => {
  const response = await api.post('/companies/', companyData)
  return response.data
}

export const getDepartments = async (): Promise<ApiResponse<Department[]>> => {
  const response = await api.get('/departments/')
  return response.data
}

export const createDepartment = async (departmentData: { name: string }): Promise<ApiResponse<Department>> => {
  const response = await api.post('/departments/', departmentData)
  return response.data
}

export const getCompanyDepartments = async (): Promise<ApiResponse<CompanyDepartment[]>> => {
  const response = await api.get('/company-departments/')
  return response.data
}

export const createCompanyDepartment = async (
  data: { companyId: string; departmentId: string }
): Promise<ApiResponse<CompanyDepartment>> => {
  const response = await api.post('/company-departments/', data)
  return response.data
}

export const updateProfile = async (data: {
  first_name: string
  last_name: string
}): Promise<ApiResponse<User>> => {
  const response = await api.patch('/settings/update-profile/', data)
  return response.data
}

export const changePassword = async (data: {
  current_password: string
  new_password: string
  confirm_password: string
}): Promise<ApiResponse<{ message: string }>> => {
  const response = await api.post('/settings/change-password/', data)
  return response.data
}
